/* Covery wishlist — one list, kept in localStorage, no account required.
 *
 * WHY localStorage and not a customer metafield: this store checks out as a guest almost every
 * time. Gating "save for later" behind a login would put a sign-up wall in front of the one
 * low-commitment action a browsing customer is willing to take. The trade-off is that the list is
 * per-device, which is the right trade for this catalogue.
 *
 * The list stores product HANDLES, never titles or prices. Anything cached would go stale against
 * Odoo; handles let the wishlist page re-render live cards from the theme itself.
 *
 * No Alpine. The matching-set section learned this the hard way — a component that waits on
 * framework boot order silently renders nothing when boot order changes. This runs on its own.
 */
(function () {
  'use strict';

  var KEY = 'covery:wishlist';
  var EVENT = 'cv:wishlist';
  var LABEL_ADD = 'Add to wishlist';
  var LABEL_REMOVE = 'Remove from wishlist';

  function read() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(KEY));
      if (!Array.isArray(raw)) return [];
      // strings only, de-duplicated, so one bad write can never poison every later read
      return raw.filter(function (h, i) {
        return typeof h === 'string' && h && raw.indexOf(h) === i;
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode / quota — the UI below still updates for this pageview */
    }
    announce(list);
  }

  function announce(list) {
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { items: list }, bubbles: true }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var at = list.indexOf(handle);
    if (at === -1) list.unshift(handle);   // newest first, which is the order the page renders
    else list.splice(at, 1);
    write(list);
    return at === -1;
  }

  function remove(handle) {
    var list = read();
    var at = list.indexOf(handle);
    if (at === -1) return false;
    list.splice(at, 1);
    write(list);
    return true;
  }

  /* ---------------------------------------------------------------- painting the UI */

  function paintButton(btn, saved) {
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = saved ? LABEL_REMOVE : LABEL_ADD;
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
    var sr = btn.querySelector('[data-cv-wish-label]');
    if (sr) sr.textContent = label;
  }

  function paintAll() {
    var list = read();
    Array.prototype.forEach.call(document.querySelectorAll('[data-cv-wish]'), function (btn) {
      paintButton(btn, list.indexOf(btn.getAttribute('data-cv-wish')) !== -1);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-cv-wish-count]'), function (el) {
      el.textContent = list.length;
      el.toggleAttribute('hidden', list.length === 0);
    });
  }

  /* One delegated listener on the document, so cards injected later — quick view, the
   * recommendations section, the wishlist page itself — work without re-binding anything. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-cv-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();          // the whole card is wrapped in a link to the product
    var handle = btn.getAttribute('data-cv-wish');
    if (!handle) return;
    var saved = toggle(handle);
    paintButton(btn, saved);
    btn.classList.remove('cv-wish--pop');
    void btn.offsetWidth;         // restart the animation on a repeat tap
    if (saved) btn.classList.add('cv-wish--pop');
  });

  document.addEventListener(EVENT, paintAll);
  // another tab changed the list
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) paintAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }

  window.CoveryWishlist = {
    read: read, has: has, toggle: toggle, remove: remove, refresh: paintAll, EVENT: EVENT
  };
})();
